module.exports = __webpack_public_path__ + "img/11-lake-and-cry_v8e_loading.90a1b41b.jpg";